import type { GetTerms200AllOf } from './getTerms200AllOf';
import type { GetTerms200AllOfThree } from './getTerms200AllOfThree';

export type GetTerms200 = GetTerms200AllOf & GetTerms200AllOfThree;
